export const sortingKeys = {
  duration: 'Duration',
  title: 'A-Z',
  release_date: 'Most recent',
  broadcast_date: 'Original air date',
} as const;

export type TSortingKey = keyof typeof sortingKeys;
